module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-date-sp_aff07cd0b0e3fd397c305f323b53a966.png";